import { render, staticRenderFns } from "./basic-picker.mpx?vue&type=template&id=8d44cc30&isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex"
import script from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex"
export * from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex"
import style0 from "./basic-picker.mpx?vue&type=style&index=0&id=8d44cc30&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_8418a540%22%7D&isComponent&outputPath=components%2Fbasic-picker8418a540%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports